import React from 'react';
import PropTypes from "prop-types";

import SEOSchema from "../../../head/SEOSchema";
import SchemaType from "../../../../types/SchemaType";

const SEOOrganizationSchema = ({ data }) => {
  const { description, name, logo, searchPath } = data;

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': SchemaType.ORGANIZATION,
    name,
    url: window.location.href,
    ...(description && { description }),
    ...(logo && logo.image_path && { logo: window.location.origin + logo.image_path }),
    "potentialAction": {
      "@type": SchemaType.SEARCH_ACTION,
      "target": `${searchPath}?keywords={query}`,
      "query-input": "required maxlength=80 name=query"
    }
  };

  return <SEOSchema data={schemaData}/>;
};

SEOOrganizationSchema.propTypes = {
  data: PropTypes.object.isRequired,
};

export default SEOOrganizationSchema;
